import type { CryptoProvider } from 'hooks/useCryptoProvider';

export type CryptoFundingProvider = CryptoProvider;

const PLACEHOLDER_TERMS_BASE_URL = 'https://example.com';

export const CRYPTO_PROVIDER_ATTRIBUTION: Record<
  CryptoFundingProvider,
  { displayName: string; termsUrl: string }
> = {
  c2c: {
    displayName: 'C2C',
    termsUrl: `${PLACEHOLDER_TERMS_BASE_URL}/c2c/terms-and-conditions`
  },
  layer1: {
    displayName: 'Layer1',
    termsUrl: `${PLACEHOLDER_TERMS_BASE_URL}/layer1/terms-and-conditions`
  }
};
